<template>
<div>
	
	<div class="container-fluid">
		<DashboardContent></DashboardContent>

	</div>
	

</div>
</template>
<script>

// import SideBar from '@/components/SideBar.vue'

import DashboardContent from '@/components/DashboardContent.vue'

export default {
   components: {
//	SideBar,
	
	DashboardContent
   }
}
</script>